import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af8fb3a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "col-12 member-h" }, "お支払い")
], -1))
const _hoisted_2 = {
  key: 0,
  class: "row justify-content-center mt-4"
}
const _hoisted_3 = { class: "col-12 member-name" }
const _hoisted_4 = {
  key: 1,
  class: "row coltable mt-3"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, "会員区分", -1))
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, "現在の有効期限", -1))
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, "お支払い後の有効期限", -1))
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, "お支払い金額", -1))
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, "お支払い後のポイント残高", -1))
const _hoisted_14 = {
  key: 0,
  class: "col-6"
}
const _hoisted_15 = {
  key: 1,
  class: "col-6"
}
const _hoisted_16 = {
  key: 2,
  class: "row mt-4 text-center"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, "現在、会員料金のお支払いは不要です。", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 3,
  class: "row payed"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, " お支払いが完了しました ", -1))
const _hoisted_21 = { class: "col-12" }
const _hoisted_22 = {
  key: 4,
  class: "row justify-content-center"
}
const _hoisted_23 = {
  key: 5,
  class: "row justify-content-center"
}

import { Member, WorkHistory, PaymentMethod, Shop } from '@/models';
import { DataStore, SortDirection } from 'aws-amplify';
import {ref, reactive, inject, onMounted, toRefs, watch} from 'vue'
import { useRoute, useRouter } from 'vue-router';

import dayjs from 'dayjs'
import 'dayjs/locale/ja'

interface Props {
  member: Member;
  shop: Shop;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    member: null,
    shop: null
  },
  emits: ['startLoading', 'stopLoading'],
  setup(__props: any, { emit }) {

const props = __props as {
  member: Member;
  shop: Shop;
}

const ADD_EXPIRE_DATE = 30;



const { member, shop } = toRefs(props);



const api: any = inject('api');

const route = useRoute();
const router = useRouter();

const price = ref(0);
const current = ref();

const success = ref(false);
const newExpire = ref();

const payment = async() => {
  if (member.value!.point! - price.value < 0) {
    return;
  }
  emit('startLoading');
  try {
    const nextExpire = dayjs().add(ADD_EXPIRE_DATE+1, 'day').format('YYYY-MM-DD');
    await api.paymentMonthly(member.value, price.value, member.value.memberType, nextExpire);
    success.value = true;
  }
  catch (e) {
    console.log(e);
  }
  emit('stopLoading');
}

watch(member, async() => {
  try {
    current.value = member.value.memberType;
    newExpire.value = dayjs().add(ADD_EXPIRE_DATE+1, 'day').format('YYYY年MM月DD日');

    if (!current.value) {
      router.push('/');
    }
    // first
    if (!member.value.memberExpire) {
      price.value = current.value.monthlyPrice!;
    }
    // Upgrade
    else if (dayjs(member.value.memberExpire) > dayjs(new Date())) {
      const diff = dayjs(member.value.memberExpire).diff(dayjs(new Date()), 'day');
      const remaining = Math.floor(current.value.monthlyPrice! * diff / ADD_EXPIRE_DATE);
      price.value = current.value.monthlyPrice! - remaining;
    }
    else {
      price.value = current.value.monthlyPrice!;
    }
  }
  catch(e){
    console.log(e);
    router.push('/login');
  }

  emit('stopLoading');
});

const getCode = () => {
  return ('000000' + member.value.codeNum).slice(-6);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_unref(member))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, _toDisplayString(_unref(member).name) + " 様", 1),
            _createElementVNode("div", null, "会員番号:" + _toDisplayString(getCode()), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(member) && !success.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(member).memberType?.name), 1),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(member).memberExpire ? _unref(dayjs)(_unref(member).memberExpire).format('YYYY年MM月DD日') : '-'), 1),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, _toDisplayString(price.value > 0 ? newExpire.value : '-'), 1),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, _toDisplayString(price.value > 0 ? price.value?.toLocaleString() + 'pt' : '-'), 1),
          _hoisted_13,
          (_unref(member).point! - price.value >= 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString((_unref(member).point! - price.value).toLocaleString()) + "pt", 1))
            : _createCommentVNode("", true),
          (_unref(member).point! - price.value < 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, "ポイントが不足しています"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (price.value <= 0 )
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
      : _createCommentVNode("", true),
    (success.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, " 有効期限 " + _toDisplayString(newExpire.value), 1)
        ]))
      : _createCommentVNode("", true),
    (!success.value && _unref(member).point! - price.value >= 0 && price.value > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", {
            class: "btn-wide-blue",
            onClick: payment
          }, " 会員料金を支払う ")
        ]))
      : _createCommentVNode("", true),
    (success.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", {
            class: "btn-wide-blue",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/')))
          }, " TOPへ戻る ")
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})